<div [loadingOverlay]="isLoading">
  @if (googleIntegrationDiagnostic) {
    <p class="text-muted small mb-3">
      Last run {{ googleIntegrationDiagnostic.InsertedDate | date: 'short' }}
    </p>
    @if (diagnosticIssues.length) {
      <ul class="list-group">
        @for (diagnosticIssue of diagnosticIssues; track diagnosticIssue.GoogleIntegrationDiagnosticIssueId) {
          <li class="list-group-item d-flex align-items-center justify-content-between gap-3">
            <span>
              {{ diagnosticIssue.GoogleIntegrationIssue.Name }}
              @if (!diagnosticIssue.WasResolved) {
                <app-components-helptext [key]="getHelpTextKey(diagnosticIssue)" [noMargin]="true"
                  popoverContainer="body"></app-components-helptext>
              }
            </span>
            @if (diagnosticIssue.WasResolved) {
              <span class="badge bg-success">
                <i class="fa fa-check-circle me-1" aria-hidden="true"></i>
                Resolved
              </span>
            } @else {
              <span class="badge bg-danger">
                <i class="fa fa-circle-xmark me-1" aria-hidden="true"></i>
                Unresolved
              </span>
            }
          </li>
        }
      </ul>
      @if (unresolvedIssueCount) {
        <div class="alert alert-danger mt-3 mb-0" role="alert">
          <strong>{{ unresolvedIssueSummary }}</strong>
          @if (isTaskContext) {
            Fix the unresolved issues, then run the diagnostic again. Workblock the task only if they can't be resolved
            from here.
          }
        </div>
      }
    } @else {
      <div class="alert alert-success mb-0" role="alert">
        <i class="fa fa-check-circle me-1" aria-hidden="true"></i>
        No integration issues were found.
      </div>
    }
  } @else if (hasLoadError) {
    <p class="text-danger mb-0">
      The latest diagnostic couldn't be loaded. Refresh and try again.
    </p>
  } @else if (!isLoading) {
    <p class="text-muted mb-0">
      No diagnostic has been performed for this customer.
    </p>
  }

  <div class="d-flex justify-content-end mt-3">
    @if (isCorrectionInProgress) {
      <span class="btn btn-primary disabled">
        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        Diagnostic in Progress...
      </span>
    } @else if (!isInCooldownPeriod) {
      <button type="button" class="btn btn-primary" [disabled]="isReadOnly || isLoading || hasLoadError"
        (click)="correctIntegration()">
        <i class="fa fa-stethoscope me-1" aria-hidden="true"></i>
        Diagnose and Fix Issues
      </button>
    } @else {
      <span class="badge bg-warning">
        <i class="fa fa-triangle-exclamation me-1" aria-hidden="true"></i>
        Diagnostic can only be run once per hour.
      </span>
    }
  </div>
</div>
